import { take } from 'lodash'
import { Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons'

import { ColorsPalette } from '../../../../config/colors'
import { getAddress } from '../../../../utils/entities/institution'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const InstitutionOptionDisplayer = ({ institution }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='institution-option-displayer flex-row ai-ctr w-100'>
      <Col className='mr-4'>
        <div style={{ width: '45px', height: '45px', backgroundColor: ColorsPalette.LIGHTER_GREY, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '3px' }}>
          <span style={{ fontWeight: 900, fontSize: '10px', color: ColorsPalette.GREY, WebkitTextStroke: '0.5px currentColor' }}>
            {take(institution.acronym, 5)}
          </span>
        </div>
      </Col>
      <Col style={{ width: 'calc(100% - 52px)' }}>
        <Row style={{ height: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <span style={{ marginLeft: '5px', fontSize: '.75rem', color: ColorsPalette.FIRST, WebkitTextStroke: '0.1px currentColor', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            <strong>{institution.name}</strong>
          </span>
        </Row>
        <Row style={{ height: '20px' }}>
          <span>
            <FontAwesomeIcon icon={faLocationDot} color={ColorsPalette.GREY} size='sm' style={{ marginLeft: '1px' }} />
            <span style={{ marginLeft: '5px', fontSize: '.75rem', color: ColorsPalette.GREY }}>
              {getAddress(institution) + ' - ' + (institution.country ? t(institution.country.name) : t('form.request.no_country'))}
            </span>
          </span>
        </Row>
      </Col>
    </div>
  )
}

export default InstitutionOptionDisplayer
